import * as React from 'react';
import * as styles from './styles.module.css';
export function ContactName(_ref) {
  var HeadingComponent = _ref.as,
      href = _ref.href,
      target = _ref.target,
      onClick = _ref.onClick,
      children = _ref.children;
  var heading = /*#__PURE__*/React.createElement(HeadingComponent, {
    as: "span",
    display: "inline-block",
    color: "current_color",
    onClick: onClick
  }, children);

  if (!href) {
    return heading;
  }

  return /*#__PURE__*/React.createElement("a", {
    href: href,
    onClick: onClick,
    target: target,
    rel: "noopener",
    className: styles['link']
  }, heading);
}